module.exports = __webpack_public_path__ + "static/media/philosophy.9bb1ff33.jpg";